import * as currency from '@shopify/theme-currency'
import m from 'mithril'

const AddToCartButton = {
  view: vnode => {
    const { events, colour, context, activeProductId, activeProductPreAvail, activeProductAvail } = vnode.attrs
    const { addCartItem } = events
    const { addToCartText, soldOutText, preorderText } = context

    if (activeProductAvail) {
      return (
        <button className={`productBlock_button button button-block button-${colour || 'green'}`}
            onclick={event => {
              event.preventDefault()
              addCartItem(activeProductId, 1, null)
            }}>{activeProductPreAvail ? preorderText : addToCartText}</button>
      )
    } else {
      return (
        <button className="productBlock_button button button-block button-disabled"
           onclick={event => {
             event.preventDefault()
           }}>{soldOutText}</button>
      )
    }
  }
}

const CartIcon = {
  view: vnode => {
    const { events, state } = vnode.attrs
    const { toggleCartVisibility } = events
    const { itemCount } = state
    const cartIcon = Shopify.Icons.Cart

    return (
      <a className="header_cart" href="#"
        onclick={event => {
          event.preventDefault()
          toggleCartVisibility()
        }}>
        <img class="icon_cart" src={cartIcon} />
        <span className="header_cartQuantity">{itemCount}</span>
      </a>
    )
  }
}

const CartItem = {
  view: vnode => {
    const { events, item, format, colourText } = vnode.attrs
    const { removeCartItem, updateCartItem } = events

    let {
      image,
      key,
      line_price,
      price,
      product_title,
      variant_title,
      quantity,
      url,
      properties,
      options_with_values,
      product_has_only_default_variant
    } = item

    const fmtPrice = currency.formatMoney(price, format)
    const fmtLinePrice = currency.formatMoney(line_price, format)
    var optionName;

    // Set option name
    if (!product_has_only_default_variant) {
      options_with_values.forEach(option => {
        if (variant_title === option.value) {
          optionName = option.name;
        }
      });
    }

    function setItemQuantity(quantity) {
      updateCartItem(key, { quantity })
    }

    return (
      <div className="cartLineItem">
        <a href={url}>
          <img className="cartLineItem_image" src={image} alt="" />
        </a>

        <div className="cartLineItem_details">
          <a className="cartLineItem_link" href={url}>
            <span className="cartLineItem_name">{product_title}</span>
            <span className="cartLineItem_description">{product_has_only_default_variant ? null : optionName + ':'} {variant_title}</span>
          </a>

          <div className="quantitySelector">
            <div className="numberStepper">
              <button className="numberStepper_button numberStepper_button-down"
                onclick={() => setItemQuantity(quantity - 1)}>decrement</button>

              <input className="numberStepper_value" type="number" min="1" value={quantity}
                 onchange={event => setItemQuantity(parseInt(event.target.value))} />

              <button className="numberStepper_button numberStepper_button-up"
                onclick={() => setItemQuantity(quantity + 1)}>decrement</button>
            </div>
          </div>

          <div className="cartLineItem_price">{fmtLinePrice}</div>
        </div>

        <a className="cartLineItem_remove" href="#"
          onclick={event => {
            event.preventDefault()
            removeCartItem(key)
          }}>&nbsp;</a>
      </div>
    )
  }
}

const Cart = {
  view: vnode => {
    const { events, context, state, format } = vnode.attrs
    const { basket } = context
    const { toggleCartVisibility } = events
    const { items, itemCount, subtotal, visible } = state
    const fmtSubtotal = currency.formatMoney(subtotal, format)
    // Spread on translations object
    const { Message, LineItems, CouponField, OrderSummary, CheckoutButton } = basket
    var checkoutButtonText;

    function setItemQuantity(quantity) {
      updateCartItem(key, { quantity })
    }

    function initiateCheckout() {
      // const discountCode = document.querySelector('.cartCoupon_input').value.toUpperCase()
      const checkoutButton = document.querySelector('#button-checkout')
      checkoutButton.setAttribute('href', '/checkout')

      // set href based on discount code field is empty or not
      // if (discountCode == '') {
      //   checkoutButton.setAttribute('href', '/checkout')
      // } else {
      //   checkoutButton.setAttribute('href', '/checkout?discount_code=' + discountCode)
      // }
    }

    function removeQueryString() {
      // window.location = window.location.href.split('?')[0];
      var newURL = location.href.split("?")[0];
      window.history.pushState('object', document.title, newURL);
    }

    // function couponFocusMessage() {
    //   const message = document.querySelector('.cartCoupon_message');
    //   message.style.opacity = '1';
    // }

    // function couponFocusMessage() {
    //   const message = document.querySelector('.cartCoupon_message');
    //   message.style.opacity = '1';
    // }

    if (itemCount <= 0) {
      checkoutButtonText = CheckoutButton.IsEmptyText
    } else {
      checkoutButtonText = CheckoutButton.GoToCheckoutText
    }

    return (
      <div className={`drawer ${visible ? 'drawer-active' : ''}`}>
        <div tabindex="0" role="button" class="drawer_backdrop" onclick={event => {
              event.preventDefault()
              toggleCartVisibility()
             }}></div>
        <div className="drawer_container">
          <div className="drawer_header">
            <a className="cart_icon-close" href="#"
             onclick={event => {
              event.preventDefault()
              toggleCartVisibility()
              // removeQueryString()
             }}><span class="actionIcon_close actionIcon_close-black"></span></a>

            <div className="cart_heading"><span>{itemCount} {OrderSummary.QuantityText}</span></div>
          </div>

          {Message ? <div className="cart_message">{Message}</div> : null}

          <div className="drawer_body">
            <div className="cartLineItems">
              {items.map(item => <CartItem events={events} format={format} item={item} colourText={LineItems.LabelColour} />)}
            </div>
          </div>

          <div className="drawer_footer">
            {CouponField.Message && itemCount > 0 ? <div className="cartCoupon">{CouponField.Message}</div> : null}

            {/* {itemCount > 0
              ?
                <div className="cartCoupon">
                  <div className="cartCoupon_field">
                    <label className="label" for="discount-code">{CouponField.Label}</label>
                    <input id="discount-code" className="cartCoupon_input input" name="discount-code" type="text" value="" placeholder={CouponField.Placeholder} onfocus={() => couponFocusMessage()} />
                  </div>
                  <div className="cartCoupon_message">{CouponField.FocusMessage}</div>
                </div>
              : ''
            } */}

            {itemCount > 0 ?
              <div className="cartOverview_orderSummary">
                <div className="cartOrderSummary">
                  <div className="cartOrderSummary_total">
                    <div className="cartOrderSummary_name">{OrderSummary.SubtotalText}</div>
                    <div className="cartOrderSummary_value">{fmtSubtotal}</div>
                  </div>

                  <div className="cartOrderSummary_total">
                    <div className="cartOrderSummary_name">{OrderSummary.ShippingText}</div>
                    <div className="cartOrderSummary_value">{OrderSummary.ShippingPrice}</div>
                  </div>
                </div>

                <form action="/checkout">

                  {Shopify.StoreCountryCode == 'dk' 
                    ?
                    <div className="cartConsent">
                      <input className="cartConsent_checkbox" type="checkbox" id="cart-consent" name="" value="" required />
                      <label for="cart-consent"><span>{ OrderSummary.ConsentText } <a target="_blank" href={ OrderSummary.ConsentLink }>{ OrderSummary.ConsentLinkText }</a></span></label>
                    </div>
                    : '' }

                  {itemCount > 0 ?
                    <button type="submit" id="button-checkout" className="button button-block button-green" onclick={() => initiateCheckout()}>{CheckoutButton.GoToCheckoutText}</button>
                  :
                    <button type="button" id="button-checkout" className="button button-block button-green" disabled>{CheckoutButton.IsEmptyText}</button>
                  }
                </form>
              </div>
            : '' }
          </div>
        </div>
      </div>
    )
  }
}

export {
  AddToCartButton,
  CartIcon,
  Cart
}
